import api from "../api";

// отримати всіх адмінів
export const getAdmins = async () => {
  const res = await api.get("/admins");
  return res.data;
};

// створити нового адміна
export const createAdmin = async (adminData) => {
  const res = await api.post("/admins", adminData);
  return res.data;
};

// змінити роль
export const updateAdminRole = async (id, role) => {
  const res = await api.put(`/admins/${id}/role`, { role });
  return res.data;
};

// видалити адміна
export const deleteAdmin = async (id) => {
  const res = await api.delete(`/admins/${id}`);
  return res.data;
};
